import React from "react";
import { Button } from "antd";

const FloatingActions = ({ onSave, onCancel }) => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        background: "#fff",
        padding: "12px 0",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 16,
        boxShadow: "0 -2px 8px rgba(0, 0, 0, 0.1)",
        borderTop: "1px solid #f0f0f0",
        zIndex: 1000,
      }}
    >
      <Button onClick={onCancel}>Cancel</Button>
      <Button type="primary" onClick={onSave}>
        Save Changes
      </Button>
    </div>
  );
};

export default FloatingActions;
